<template>
  <el-table :data="tableData" stripe>
    <el-table-column prop="operate" label="操作" width="100" align="center">
      <template slot-scope="{ $index, row }">
        <el-link :disabled="tableData.length >= 3" :underline="false" style="margin-right: 10px" @click="plus($index)">
          <i class="el-icon-add-group"></i>
        </el-link>
        <el-link :disabled="tableData.length <= 1" :underline="false" @click="minus($index)"><i class="el-icon-sub"></i></el-link>
      </template>
    </el-table-column>
    <el-table-column prop="pricerange_beginAmount" label="购买数量" width="140" align="center">
      <template slot-scope="{ row }">
        <el-input-digit autofocus v-model.number="row.pricerange_beginAmount" placeholder="请输入" :precision="0" style="width: 110px" />
      </template>
    </el-table-column>
    <el-table-column prop="pricerange_price" label="单价" width="140" align="center">
      <template slot-scope="{ row }">
        <el-input-digit autofocus v-model.number="row.pricerange_price" placeholder="请输入" :precision="8" style="width: 110px" />
      </template>
    </el-table-column>
    <el-table-column prop="preview" label="预览（可根据买家采购的不同数量设置不同价格）" width="300" align="center">
    </el-table-column>
  </el-table>
</template>

<script>
import storeMixins from '../store-mixins';
export default {
  mixins: [storeMixins],
  props: ['props'],
  data() {
    return {
      tableData: [],
    };
  },
  computed: {
    key() {
      return this.props.name;
    },
    _values() {
      return this.alibabaForm[this.key];
    },
  },
  watch: {
    _values: {
      handler(str) {
        let list = str ? JSON.parse(str) : [];
        if(!Array.isArray(list)) {
          list = []
        }
        if(!list.length) {
          list.push({ pricerange_beginAmount: '', pricerange_price: '' })
        }
        list.forEach(item => {
          item.preview = '';
        });
        this.tableData = list;
      },
      immediate: true,
    },
    tableData: {
      handler() {
        this.updateTableData();
      },
      immediate: true,
      deep: true
    },
    'alibabaForm.cbuUnit'() {
      this.updateTableData();
    },
  },
  methods: {
    plus($index) {
      this.tableData.splice($index + 1, 0, { pricerange_beginAmount: '', pricerange_price: '', preview: '' });
    },
    minus($index) {
      this.tableData.splice($index, 1);
    },
    updateTableData() {
      const cbuUnit = this.alibabaForm.cbuUnit || '';
      const valueList = this.tableData.map((row, index) => {
        let preview = '';
        let { pricerange_beginAmount, pricerange_price } = row;
        const next = this.tableData[index + 1];
        if (pricerange_beginAmount && pricerange_price) {
          if (next && next.pricerange_beginAmount) {
            preview = `${pricerange_beginAmount}-${next.pricerange_beginAmount - 1} ${cbuUnit} : ${pricerange_price} / ${cbuUnit}`;
          } else {
            preview = `>=${pricerange_beginAmount} ${cbuUnit} : ${pricerange_price} / ${cbuUnit}`;
          }
        }
        row.preview = preview;
        return {
          pricerange_beginAmount: row.pricerange_beginAmount,
          pricerange_price: row.pricerange_price,
        };
      });
      this.updateAlibabaForm({ [this.key]: JSON.stringify(valueList) });
    },
  },
  mounted() {},
};
</script>
  
  <style></style>